import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { getSearch } from '../../utils/http'
import Selected from './Selected'
import Choose from './Choose'
import SchoolDetail from './SchoolDetail'
import './index.less'
import { getPurposeSchoolAndSpecialty } from '../../api/schoolWishList';

class SchoolWishList extends Component {

  state = {
      selectedSchoolList:[],
      selectedSchoolIds:[],
  }

  componentWillMount() {
      //获取意向学校和专业
      getPurposeSchoolAndSpecialty().then(res => {
          if(res.data){
              let selectedSchoolIds=[];
              res.data.universities.forEach(i=>{
                  selectedSchoolIds.push(i.id)
              });
              this.setState({
                  selectedSchoolList:res.data.universities,
                  selectedSchoolIds,
              })
          }
      });
  }

  handleSelectChange(newIds,newList) {
    this.setState(() => {
      return {
          selectedSchoolList:newList,
          selectedSchoolIds:newIds,
      }
    });

  }

  render() {
    const { match } = this.props;
    const { selectedSchoolIds,selectedSchoolList } = this.state;
    return (
      <Switch>
        <Route exact path={`${match.url}`} render={props =>
          <Selected selectedSchoolIds={selectedSchoolIds} selectedSchoolList={selectedSchoolList} onSelectChange={this.handleSelectChange.bind(this)} {...props} />
        } />
        <Route path={`${match.url}/choose`} render={props =>
          <Choose selectedSchoolIds={selectedSchoolIds} selectedSchoolList={selectedSchoolList}  onSelectChange={this.handleSelectChange.bind(this)} {...props} />
        } />
        <Route path={`${match.url}/school/:id`} render={props =>
          <SchoolDetail selectedSchoolIds={selectedSchoolIds} selectedSchoolList={selectedSchoolList}  onSelectChange={this.handleSelectChange.bind(this)} {...props} />
        } />

      </Switch>
    )
  }
}

export default SchoolWishList



// WEBPACK FOOTER //
// ./src/pages/SchoolWishList/index.js